import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { gql } from "apollo-boost";
import { useLazyQuery } from "@apollo/react-hooks";
import "./ProductBrandInfo.css";
import IconRemove from "../../../assets/icon_remove.svg";

const SEARCH_BRANDS = gql`
  query SearchBrands($query: String!, $offset: Int!, $limit: Int!) {
    searchBrands(query: $query, offset: $offset, limit: $limit) {
      id
      name
      name_kr
    }
  }
`;

/**
 * Upload - 브랜드 등록
 * @param register
 * @param watch
 * @param setValue
 * @returns {Element}
 * @constructor
 */
const ProductBrandInfo = ({ register, watch, setValue }) => {
  const brandFromForm = watch("brand") || "";

  const [brandQuery, setBrandQuery] = useState("");
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [brandResults, setBrandResults] = useState([]);
  const [selectedBrandIndex, setSelectedBrandIndex] = useState(-1);

  const [searchBrands] = useLazyQuery(SEARCH_BRANDS, {
    onCompleted: (data) => {
      if (data && data.searchBrands) {
        setBrandResults(data.searchBrands);
      }
    },
  });

  const handleBrandSearch = (e) => {
    const query = e.target.value;
    setBrandQuery(query);
    setSelectedBrand(null);
    setValue("brand", "");

    if (query.length >= 1) {
      searchBrands({ variables: { query, offset: 0, limit: 10 } });
      setSelectedBrandIndex(-1);
    } else {
      setBrandResults([]);
    }
  };

  const handleSelectBrand = (brand, index) => {
    setSelectedBrand(brand);
    setBrandQuery("");
    setValue("brand", brand.name);
    setSelectedBrandIndex(index);
    setBrandResults([]);
  };

  const handleRemoveBrand = () => {
    setSelectedBrand(null);
    setValue("brand", "");
    setBrandQuery("");
    setSelectedBrandIndex(-1);
  };

  useEffect(() => {
    if (brandFromForm) {
      if (!selectedBrand || selectedBrand.name !== brandFromForm) {
        setSelectedBrand({ name: brandFromForm });
        setBrandQuery("");
      }
    } else {
      if (selectedBrand) {
        setSelectedBrand(null);
        setBrandQuery("");
        setSelectedBrandIndex(-1);
      }
    }
  }, [brandFromForm]);

  return (
    <div className="ProductBrandInfo-container">
      <div className="input-header">
        <label>브랜드</label>
      </div>
      <div className="ProductBrandInfo-brandInputArea">
        {selectedBrand ? (
          <div className="form-input">
            <span className="ProductBrandInfo-brandName">
              {selectedBrand.name}
            </span>
            <button
              type="button"
              className="ProductBrandInfo-removeBrandButton"
              onClick={handleRemoveBrand}
            >
              <img src={IconRemove} alt={"제거하기"} />
            </button>
          </div>
        ) : (
          <div className="ProductBrandInfo-searchContainer">
            <input
              type="text"
              placeholder="브랜드를 선택해주세요"
              value={brandQuery}
              onChange={handleBrandSearch}
              className="form-input"
            />
          </div>
        )}
      </div>
      {brandQuery && !selectedBrand && brandResults.length > 0 && (
        <div className="ProductBrandInfo-brandSearchResults">
          {brandResults.map((brand, index) => (
            <div
              key={brand.id}
              className={`ProductBrandInfo-brandResultItem ${selectedBrandIndex === index ? "ProductBrandInfo-brandResultItem--selected" : ""}`}
              onClick={() => handleSelectBrand(brand, index)}
              // onKeyDown 등 키보드 네비게이션 추가 가능
            >
              <span className="name">{brand.name}</span>
              <span className="name-kr">{brand.name_kr}</span>
            </div>
          ))}
        </div>
      )}
      <input type="hidden" {...register("brand")} />
    </div>
  );
};

ProductBrandInfo.propTypes = {
  register: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};

export default ProductBrandInfo;
